import './App.css';

import React from 'react';
import profileData from "./profiledata.json";
import Modal from 'react-bootstrap/Modal';

function Card(props) {
    const [modalShow, setModalShow] = React.useState(false);
    const [listItem, setListItem] = React.useState({});

    return (
        <>
            <BootstrapModal
                show={modalShow}
                listItem={listItem}
                onHide={() => setModalShow(false)}
            />
            <div key={props.portfolioItem.id} className="card-item text-start col-sm-12 col-md-6 col-xl-4" variant="primary" onClick={() => { setModalShow(true); setListItem(props.portfolioItem) }} >
                <div className="card-body">
                    <h2 className="card-title mb-2">{props.portfolioItem.title}</h2>
                </div>
                <div className="img-wrapper">
                    <img className="card-img-top" src={props.portfolioItem.img} alt={props.portfolioItem.imgalt} />
                </div>
            </div>
        </>
    );
}

function CardList() {

    return (
        <div className="row">
            {profileData.map(portfolioItem => (
                <Card key={portfolioItem.id} portfolioItem={portfolioItem} />
            ))}
        </div>
    )
}

function BootstrapModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {(props.listItem.url && props.listItem.url.trim() !== '') &&
                        <h3><a href={props.listItem.url} target='_blank' rel="noreferrer">{props.listItem.title}</a></h3>
                    }
                    {(!props.listItem.url) &&
                        <h3>{props.listItem.title}</h3>
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col col-sm-4">
                        {(props.listItem.role && props.listItem.role.trim() !== '') &&
                            <p><strong>Roles and responsibilities:</strong><br />
                                {props.listItem.role}</p>
                        }
                        {(props.listItem.cms && props.listItem.cms.trim() !== '') &&
                            <p><strong>Content Management System:</strong><br />
                                {props.listItem.cms}</p>
                        }
                        {(props.listItem.technologies && props.listItem.technologies.trim() !== '') &&
                            <p><strong>Technologies:</strong><br />
                                {props.listItem.technologies}</p>
                        }
                    </div>
                    <div className="col col-sm-8 text-center">
                        {(props.listItem.url && props.listItem.url.trim() !== '') &&
                            <a href={props.listItem.url} target='_blank' rel="noreferrer"><img className="modal-img" src={props.listItem.img} alt={props.listItem.imgalt} /></a>
                        }
                        {(!props.listItem.url) &&
                            <img className="modal-img" src={props.listItem.img} alt={props.listItem.imgalt} />
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

function App() {
    return (
        <div className="App">
            <div className="navbar navbar-dark bg-dark shadow-sm pb-4 mb-4">
                <div className="container">
                    <button type="button" class="btn btn-primary"><a href="email-templates.html">Email Templates</a></button>
                </div>
            </div>
            <div className="container pt-4">
                <CardList />
            </div>

            <p>&copy; Gabor Kolcza {(new Date().getFullYear())}. All rights reserved.</p>
        </div>
    );
}

export default App;







// "homepage": "http://gaborkolcza.ca/react/",   ---> "homepage": "http://gaborkolcza.ca/",
// "homepage": "https://gaborrr.github.io/gaborkolcza",

// WORKING HERE:   
// C:\Users\Gabor\Desktop\GAB\DEVELOPMENT\gaborkolcza_ca\react-website\


///////////////////////////////////////////////////////////////////////////////////////
// TODO      // ORKING and TESTING in the REACTFOLDERR react

//add to git Private 


// check if I can do that here  add it after the component include name <Card />
{/* <style jsx>{`
    .app-newsletter {
        display: flex;
        padding: 4rem;
    }
`}</style> */}


// - check in edge and firefox and safari

// when sending and reciving props in card component from cardlist us destructuring reciving and when sending use object with spread operator

// remove from package json        "web-vitals": "^2.1.4"    ???????
////add to git after the basic functionality works on github
// - remove personal data from json

// !!!!!!!!!!!!!!!!!!!! make sure nothing hrmful coming from JSON how to do that ??????


// add Analytics to my site -- CHECK existing ?

// - 	- check with  google lightsomething
// optimize images
// check other suggestions

// Phase 2
//add email templates as a filter
// TODO PWA make it a PWA -- check in lighthouse how to do that


///////////////////////////////////////////////
// BEFORE GO TO PROD
// update homepage in the package.json to have it in the root - try it 
// "homepage": "http://gaborkolcza.ca/react/",   ---> "homepage": "http://gaborkolcza.ca/",
// - backup old site first





// Phase 3-5
//setup mongoDB
//setup jest
// - for normal testing
// - for mongoDB API testing
// Server Side rendering Next.js Express ?


// LATER
// add more images ? precima_2 ???



// TODO set them up ??? under gaborkolcza???
// http://clients.humbertech.com/colettes/
// http://clients.humbertech.com/bmw/
// http://archive.humbertech.com/woofshirefarms/
// http://archive.humbertech.com/cherryhillrestaurant/
// http://archive.humbertech.com/harttmortgage/
// http://archive.humbertech.com/focalpane/
// http://archive.humbertech.com/ultimatetrim/
// http://archive.humbertech.com/floorguy/
// http://archive.humbertech.com/exploremixing/
// http://archive.humbertech.com/circuitfitness
// http://archive.humbertech.com/norris/




////////////////////////////////////////////////////////////////////////////////
// DONE


// copy gaborkolcza static to oldwebsite
//test oldwebsite website

// DO THIS
// update homepage in the package.json to have it in the root - try it
// "homepage": "http://gaborkolcza.ca/react/",   ---> "homepage": "http://gaborkolcza.ca/",

//build and deploy and test

// backup old one on /static
//backup gaborkolcza.ca

// fix bug AMS credit car modal missing image and title

//update the roles on the website modal to be better

// change class to className  all 
//setup link but if url is emty do not link it
// align the modal text better

//  setup in the JSON all portfolio item 
//fix id s in the JSON

// all items in modal only display label if it is not empty : props.listItem.cms
// accountabilityreport.loyalty.com   cms is emty string

// - rename modal funciton name : "MyVerticallyCenteredModal"
//setup cards componenent -- seperate from card list
//style modal
//get data in modal from the json through card list
//check how it looks on all devices if there is only one or 2 item in a row
// fix image src locally images localy
// setup style for the card
// layout check on mobile tablet and desktop
//   - layout small 1
//   - medium 2
//   - large 3
// setup modal somehow - add bootstrap extension ???
// get json data from json file 
// setup the list of the cards in html
//add the images in one folder
// - stup 2 item with json 
// - try the build how to go prod deploy 